import { useNavigate } from 'react-router-dom';

import { Routes } from 'constants/routes';

export const useCreatePasswordRedirect = () => {
    const navigate = useNavigate();
    return (token: string) =>
        navigate(Routes.CREATE_PASSWORD.replace(/:.*\?/u, token));
};
